// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.INujkBMeuTb8VtKblb92 {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Lj69VLphc9z3nNvLbpwy {
  max-width: 700px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

.TH3u3Z7xRvWkRh12SsLN {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 16px;
}

.RxyBFHVX6aQvH7DS90Jk {
  min-width: 180px;
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/screens/UserAdministration/BroadcastNotification.module.scss"],"names":[],"mappings":"AACA;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAAF","sourcesContent":["\r\n.broadcastNotificationModalContainer {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.broadcastNotificationModal {\r\n  max-width: 700px;\r\n  padding: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 32px;\r\n}\r\n\r\n.recipientRow {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  column-gap: 16px;\r\n}\r\n\r\n.checkboxContainer {\r\n  min-width: 180px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"broadcastNotificationModalContainer": `INujkBMeuTb8VtKblb92`,
	"broadcastNotificationModal": `Lj69VLphc9z3nNvLbpwy`,
	"recipientRow": `TH3u3Z7xRvWkRh12SsLN`,
	"checkboxContainer": `RxyBFHVX6aQvH7DS90Jk`
};
export default ___CSS_LOADER_EXPORT___;
